module.exports = __webpack_public_path__ + "static/media/mulesoft.611283c3.png";